export default {
  init() {
    document
      .getElementById('submitBtn')
      .addEventListener('click', function (event) {
        event.preventDefault();

        // Get form fields
        const firstName = document.getElementById('firstName-vaguide');
        const lastName = document.getElementById('lastName-vaguide');
        const email = document.getElementById('email-vaguide');
        const phone = document.getElementById('phone-vaguide');
        const submitBtn = document.getElementById('submitBtn');
        const form = document.getElementById('va-buyers-guide-form');
        const successMessage = document.getElementById('successMessage');
        const errorEl = document.getElementById('vaguide-error');

        // Clear previous errors and red borders
        const removeExistingErrors = () => {
          document.querySelectorAll('.error-message').forEach((errorEl) => {
            errorEl.remove();
          });
          [firstName, lastName, email, phone].forEach((field) => {
            field.style.borderBottom = '2px solid white'; // Reset to white bottom border
          });
        };
        removeExistingErrors();

        let hasError = false;

        // Helper function to create and insert error message
        const displayError = (inputElement, message) => {
          inputElement.style.borderBottom = '2px solid red'; // Red bottom border for error
          const errorEl = document.createElement('p');
          errorEl.classList.add(
            'error-message',
            'text-xs', // smaller text
            'italic' // italic text
          );
          errorEl.innerText = message;
          errorEl.style.color = 'red'; // Red text color
          inputElement.parentNode.appendChild(errorEl); // Insert after the input field
        };

        // Email validation function
        const isValidEmail = (emailValue) => {
          const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
          return emailPattern.test(emailValue);
        };

        // Check if fields are filled
        if (!firstName.value) {
          displayError(firstName, 'First Name is required');
          hasError = true;
        }
        if (!lastName.value) {
          displayError(lastName, 'Last Name is required');
          hasError = true;
        }
        if (!email.value) {
          displayError(email, 'Email is required');
          hasError = true;
        } else if (!isValidEmail(email.value.trim())) {
          displayError(email, 'Please enter a valid email address');
          hasError = true;
        }
        if (!phone.value) {
          displayError(phone, 'Phone is required');
          hasError = true;
        }

        // If there's an error, prevent form submission
        if (hasError) {
          return;
        }

        // Disable the button and show loading state
        submitBtn.disabled = true;
        submitBtn.value = 'Loading...';

        // Data to send
        const dataToSend = {
          FirstName: firstName.value,
          LastName: lastName.value,
          Email: email.value,
          Phone: phone.value,
          CampaignName: 'Consumers-VA Loans',
          CampaignStatus: 'Active',
          Source: 'VA Guide Arbor Microsite',
        };

        fetch('https://hooks.zapier.com/hooks/catch/5841802/2he39px/', {
          method: 'POST',
          body: JSON.stringify(dataToSend),
        })
          .then((response) => response.json())
          .then((data) => {
            console.log(data);
            if (data.status === 'success') {
              // Hide the form and show the success message
              form.style.display = 'none';
              // Hide class compliance-section
              document.querySelector('.compliance-section').style.display =
                'none';
              successMessage.classList.remove('hidden');
            }

            setTimeout(() => {
              window.open(
                'https://arborhl.com/assets/files/VA%20Home%20Loans%20Guide.pdf',
                '_blank'
              );
            }, 1200);
          })
          .catch(() => {
            // Show error message
            errorEl.style.display = 'block';
          })
          .finally(() => {
            // Reset the button state
            submitBtn.disabled = false;
            submitBtn.value = 'Download Now';

            // Reset form fields
            firstName.value = '';
            lastName.value = '';
            email.value = '';
            phone.value = '';
          });
      });
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/vaLoans.js